<script>
  import asset from "@helpers/asset"

  export { className as class }
  export let src
  export let alt
  export let aspect = "original"
  export let width = 1024
  export let height
  export let quality = 80

  const Aspect = {
    original: "",
    square: "[ aspect-square ]",
  }

  let className = ""
  $: url = asset(src, { height, width, quality })
</script>

<div class="{className} {Aspect[aspect]} [ bg-contain bg-center bg-no-repeat ]" style="background-image: urL({url})">
  <img src={url} {alt} class="[ sr-only ]" />
</div>
